/**
 * 비상벨 API 클라이언트 — backend /emergency-bell-sales/* 와 1:1.
 */

import { todayKst } from './date-label';
import type { ApiResponse, ApiResponseList, EmergencyBellRow } from './types';

const BASE = '/api';

/**
 * 비상벨 「납품기한 도래 현황」 공유 보고서 PDF (누르는 날 기준).
 *   - 종결·취소 제외 전체
 *   - 납기 오름차순 정렬
 *   - 검사검수요청(연초록)·도래(노랑)·경과(분홍) 색 + 표 아랫줄 건수 (v2.312.0 · 개발요청 #28)
 */
export async function downloadBellStatusPdf(): Promise<void> {
  const res = await fetch(`${BASE}/emergency-bell-sales/status.pdf`, {
    credentials: 'include',
  });
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(`납기현황 다운로드 실패 (${res.status}): ${txt}`);
  }
  const blob = await res.blob();
  const cd = res.headers.get('Content-Disposition') ?? '';
  const match = /filename\*=UTF-8''([^;]+)/.exec(cd);
  const stamp = todayKst().slice(2).replace(/-/g, '');
  const filename = match ? decodeURIComponent(match[1]!) : `${stamp}_비상벨 납품기한 도래현황.pdf`;
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export interface BellListParams {
  page?: number;
  pageSize?: number;
  q?: string;
  status?: string[];
  year?: number;
  invoiceOnly?: boolean;
}

export async function listBell(params: BellListParams = {}): Promise<{
  data: EmergencyBellRow[];
  page: { page: number; pageSize: number; total: number };
}> {
  const qs = new URLSearchParams();
  if (params.page) qs.set('page', String(params.page));
  if (params.pageSize) qs.set('pageSize', String(params.pageSize));
  if (params.q) qs.set('q', params.q);
  if (params.year !== undefined) qs.set('year', String(params.year));
  if (params.invoiceOnly) qs.set('invoiceOnly', 'true');
  if (params.status && params.status.length > 0) {
    for (const s of params.status) qs.append('status', s);
  }
  const res = await fetch(`${BASE}/emergency-bell-sales?${qs.toString()}`, {
    credentials: 'include',
  });
  const json = (await res.json()) as ApiResponseList<EmergencyBellRow>;
  if (!json.ok) throw new Error(json.error.message);
  return { data: json.data, page: json.page };
}

export async function listBellYears(): Promise<string[]> {
  const res = await fetch(`${BASE}/emergency-bell-sales/years`, { credentials: 'include' });
  const json = (await res.json()) as ApiResponse<string[]>;
  if (!json.ok) throw new Error(json.error.message);
  return json.data;
}
